/**
 * @generated SignedSource<<b6e00b43bd29f595a954ba2f8f18097c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductSkuImage_Product$data = {
  readonly skus: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ProducSkuImageMobile_ProductSku" | "ProducSkuImageDesktopProps_ProductSku">;
      };
    }>;
  };
  readonly " $fragmentType": "ProductSkuImage_Product";
};
export type ProductSkuImage_Product$key = {
  readonly " $data"?: ProductSkuImage_Product$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductSkuImage_Product">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSkuImage_Product",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductSkuConnection",
      "kind": "LinkedField",
      "name": "skus",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductSkuEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProductSku",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProducSkuImageMobile_ProductSku"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProducSkuImageDesktopProps_ProductSku"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "167bec5cfda0aee5f646ed3a8599b702";

export default node;
